module.exports = __webpack_public_path__ + "img/landing_banner.0249846a.png";